/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:25:23
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title24 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P24 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
      mySize: {  // 模版大小
        width: 510, 
        height: 680 
      },
      padding: '0 0'
    }
  }

  render() {
    const { mySize, chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage size={mySize} padding={this.state.padding}>
        <div className={s.box}>
          <Title24 pageNumber="1.5">全年行业热点事件与传播趋势</Title24>
          <div className={s.content} >
            <div style={{ paddingBottom: 4 }}>
              <div contentEditable className={s.des}>
                全年行业全年热点频发。4月18日，汽车行业达到数字口碑价值最高峰，单日DB值达<span contentEditable>787,108,565</span>DB，主要原因是上海国际车展各大车企的集中火力传播
              </div>
              <div contentEditable className={s.des}>
              “价格战”贯穿全年；车展、发布会中的新产品、新技术是车企传播的重点。
              </div>
              <div contentEditable className={s.subTitle}>
                汽车行业 单日口碑价值与单日全网内容条数变化
              </div>
              <div contentEditable className={s.subTitle_2}>
                数据来源：数字品牌榜
              </div>
              <div contentEditable className={s.subTitle_2}>
                时间窗口: 20230101-20231231
              </div>
            </div>

            <div className={s.uiWrapper}>
              <div className={s.chartWrapper}>
                <TooltipDrawer
                  style={{ width: '100%', height: '100%' }}
                  formContent={<Form onChange={values => this.setState({ ...values })} />}>
                  <div contentEditable className={s.unitText_1}>单位: <i>DB</i></div>
                  <Chart options={setChart({
                    label: chartTitle,
                    list: chartList,
                    color: chartColorList
                  })} />
                  <div contentEditable className={s.unitText_2}>单位: 条</div>
                </TooltipDrawer>
              </div>
            </div>
          </div>
        </div>

      </Stage>
    );
  }
}

export default withStyles(s)(P24);



// WEBPACK FOOTER //
// src/routes/visualChart/P24/index.js